import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Select, { selectClasses } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';
import { fetchInboxSortBy } from 'venuescanner-js/constants/thread';

const sortFilters = {
  host: [
    { label: 'Organiser name', value: fetchInboxSortBy.ORGANISER_NAME },
    { label: 'Space name', value: fetchInboxSortBy.SPACE_NAME },
    { label: 'Event date', value: fetchInboxSortBy.EVENT_DATE },
    { label: 'Last action date', value: fetchInboxSortBy.LAST_ACTION_DATE },
  ],
  organiser: [
    { label: 'Venue name', value: fetchInboxSortBy.VENUE_NAME },
    { label: 'Host name', value: fetchInboxSortBy.HOST_NAME },
    { label: 'Event date', value: fetchInboxSortBy.EVENT_DATE },
    { label: 'Last action date', value: fetchInboxSortBy.LAST_ACTION_DATE },
  ],
};

const SortSelect = styled(Select)(({ theme }) => ({
  [`& .${selectClasses.icon}`]: {
    color: '#424242',
    right: 0,
  },

  [`& .${selectClasses.select}`]: {
    fontWeight: 400,
    fontSize: theme.typography.caption.fontSize,
    lineHeight: '16px',
    maxWidth: '104px',
    minHeight: '0 !important',
    padding: 0,
  },

  [`& .${selectClasses.nativeInput}`]: {
    border: 0,
    padding: 0,
  },

  '& fieldset': {
    border: 0,
  },

  [`& .${selectClasses.select}:focus`]: {
    backgroundColor: 'transparent',
  },
}));

const SelectMenuItem = styled(MenuItem)(({ theme }) => ({
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: theme.typography.subtitle2.fontSize,
  lineHeight: '24px',
  letterSpacing: '.17px',
  minHeight: 0,
}));

const SortLabel = styled(Typography)(({ theme }) => ({
  color: '#979797',
  fontSize: theme.typography.caption.fontSize,
  lineHeight: '16px',
  fontStyle: 'normal',
  mb: '2px',
}));

const EnquirySort = ({ userType }) => {
  const { threadsSort, setThreadsSort } = useContext(ViewContext);
  const [sort, setSort] = useState(threadsSort);

  const handleChange = event => {
    setThreadsSort(event.target.value);
  };

  useEffect(() => {
    if (threadsSort !== sort) {
      inboxService.threads();
      setSort(threadsSort);
    }
  }, [threadsSort]);

  return (
    <Box
      display='flex'
      mt={{ xs: 2, sm: 0 }}
      alignItems={{ xs: 'center', sm: 'flex-start' }}
      justifyContent={{ xs: 'flex-end' }}
      flexDirection={{ xs: 'row', sm: 'column' }}>
      <Box mr={{ xs: 1, sm: 0 }}>
        <SortLabel variant='caption'>Sort by:</SortLabel>
      </Box>
      {userType ? (
        <Box>
          <SortSelect value={threadsSort} onChange={handleChange}>
            {sortFilters[userType].map((sortFilter, index) => (
              <SelectMenuItem key={index} value={sortFilter.value}>
                {sortFilter.label}
              </SelectMenuItem>
            ))}
          </SortSelect>
        </Box>
      ) : null}
    </Box>
  );
};

EnquirySort.propTypes = {
  userType: PropTypes.string.isRequired,
};

export default EnquirySort;
